(function () {
  try {
    if (window.__tvCutoffInit) return;
    window.__tvCutoffInit = true;

    var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var fmtCache = {};
    function partsFmtFor(tz) {
      if (!fmtCache[tz]) {
        fmtCache[tz] = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          hourCycle: 'h23',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          weekday: 'short'
        });
      }
      return fmtCache[tz];
    }

    var localFmt = new Intl.DateTimeFormat(undefined, {
      hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
    });

    function fmtLeft(msLeft) {
      var total = Math.floor(msLeft / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      if (h > 0) return h + 'h ' + m + 'm';
      var s = total % 60;
      if (m > 0) return m + 'm ' + s + 's';
      return s + 's';
    }

    var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ESC[c]; }); }
    function two(n) { return n < 10 ? '0' + n : '' + n; }
    function segHtml(msLeft) {
      var total = Math.max(0, Math.floor(msLeft / 1000));
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      function seg(n, label) {
        return '<span class="tv-promo-seg"><b>' + two(n) + '</b><small>' + label + '</small></span>';
      }
      var colon = '<span class="tv-promo-colon" aria-hidden="true">:</span>';
      return seg(h, 'hrs') + colon + seg(m, 'min') + colon + seg(s, 'sec');
    }

    function bind(el) {
      if (el.__tvCutoffBound) return;
      el.__tvCutoffBound = true;

      var tz = el.getAttribute('data-tv-cutoff-tz') || 'America/New_York';
      var hhmm = (el.getAttribute('data-tv-cutoff') || '14:00').split(':');
      var cutH = parseInt(hhmm[0], 10);
      var cutM = parseInt(hhmm[1], 10) || 0;
      var tpl = el.getAttribute('data-tv-cutoff-tpl') || '';
      if (isNaN(cutH) || !tpl) return;
      var segFmt = el.getAttribute('data-tv-cutoff-format') === 'segments' && tpl.indexOf('[time]') > -1;

      var daysRaw = (el.getAttribute('data-tv-cutoff-days') || '1,2,3,4,5').split(',');
      var days = {};
      for (var i = 0; i < daysRaw.length; i++) {
        var d = parseInt(daysRaw[i], 10);
        if (!isNaN(d)) days[d] = 1;
      }

      var partsFmt = partsFmtFor(tz);
      function partsAt(ms) {
        var p = partsFmt.formatToParts(new Date(ms));
        var o = {};
        for (var i = 0; i < p.length; i++) if (p[i].type !== 'literal') o[p[i].type] = p[i].value;
        return o;
      }
      function offsetAt(ms) {
        var o = partsAt(ms);
        var asUTC = Date.UTC(+o.year, +o.month - 1, +o.day, (+o.hour) % 24, +o.minute, +o.second);
        return Math.round((asUTC - Math.floor(ms / 1000) * 1000) / 60000);
      }
      function zonedToUtc(y, m, d, h, mi) {
        var naive = Date.UTC(y, m - 1, d, h, mi, 0);
        var ms = naive - offsetAt(naive) * 60000;
        ms = naive - offsetAt(ms) * 60000;
        return ms;
      }
      function todayIn(ms) {
        var o = partsAt(ms);
        return { y: +o.year, m: +o.month, d: +o.day, wd: WD[o.weekday] };
      }

      var timer = null;
      function state(v) { if (segFmt) el.setAttribute('data-tv-cutoff-state', v); }
      function hide() { el.hidden = true; el.textContent = ''; el.__tvLast = null; el.__tvSegNums = null; state('off'); }
      function render() {
        var now = Date.now();
        var t = todayIn(now);
        if (!days[t.wd]) { hide(); return 0; }
        var cutoffMs = zonedToUtc(t.y, t.m, t.d, cutH, cutM);
        var left = cutoffMs - now;
        if (left <= 0) { hide(); return 0; }
        var full = tpl.replace('[cutoff]', localFmt.format(new Date(cutoffMs)));
        if (segFmt) {
          if (el.__tvLast !== full || !(el.__tvSegNums && el.__tvSegNums.length && el.contains(el.__tvSegNums[0]))) {
            var at = full.indexOf('[time]');
            el.innerHTML = esc(full.slice(0, at)) +
              '<span class="tv-promo-segs" aria-hidden="true">' + segHtml(left) + '</span>' +
              esc(full.slice(at + 6)) +
              '<span class="tv-promo-sr"></span>';
            el.__tvLast = full;
            el.__tvSegNums = el.querySelectorAll('.tv-promo-seg b');
            el.__tvSr = el.querySelector('.tv-promo-sr');
          }
          var sv = Math.max(0, Math.floor(left / 1000));
          var dv = [two(Math.floor(sv / 3600)), two(Math.floor((sv % 3600) / 60)), two(sv % 60)];
          for (var di = 0; di < el.__tvSegNums.length && di < 3; di++) if (el.__tvSegNums[di].textContent !== dv[di]) el.__tvSegNums[di].textContent = dv[di];
          var srTxt = full.replace('[time]', fmtLeft(left));
          if (el.__tvSr && el.__tvSr.textContent !== srTxt) el.__tvSr.textContent = srTxt;
          state('on');
          el.hidden = false;
          return left;
        }
        var txt = full.replace('[time]', fmtLeft(left));
        if (el.textContent !== txt) el.textContent = txt;
        el.hidden = false;
        return left;
      }
      function schedule() {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!el.isConnected) return;
        var left = render();
        if (left <= 0) return;
        timer = setTimeout(schedule, segFmt || left < 3600000 ? 1000 : 30000);
      }
      el.__tvCutoffKick = schedule;
      schedule();
    }

    function scan(root) {
      var list = (root || document).querySelectorAll('[data-tv-cutoff-tpl]');
      for (var i = 0; i < list.length; i++) bind(list[i]);
    }

    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(); }, 200);
    });

    function start() {
      scan();
      mo.observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      var list = document.querySelectorAll('[data-tv-cutoff-tpl]');
      for (var i = 0; i < list.length; i++) if (list[i].__tvCutoffKick) list[i].__tvCutoffKick();
    });
  } catch (e) { }
})();
